module.exports = __webpack_public_path__ + "bg2.491b62e37ab547d019e0.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/assets/img/bg2.png
// module id = ../../../../../src/assets/img/bg2.png
// module chunks = main